import { gql } from 'apollo-angular'

export const CONFIGURE_SUBSCRIPTIONS = gql`
  mutation configureSubscriptions(
    $organizationId: Int
    $reference: String
    $productsToAdd: [ConfigureSubscriptionsProductToAddInput!]
    $subscriptionsToUpdate: [ConfigureSubscriptionsSubscriptionsToUpdateInput!]
  ) {
    configureSubscriptions(
      data: {
        organizationId: $organizationId
        reference: $reference
        productsToAdd: $productsToAdd
        subscriptionsToUpdate: $subscriptionsToUpdate
      }
    ) {
      paymentUrl
    }
  }
`
